module.exports = __webpack_public_path__ + "img/map.2953e543.png";